import { styled, SxProps, Theme } from "@mui/material";

type BasicCardContentProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const BasicCardContent = ({ children, sx }: BasicCardContentProps) => {
  return <CardContent sx={sx}>{children}</CardContent>;
};

const CardContent = styled("div")(() => ({
  padding: "1rem",
}));
